import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function TopNavbar() {
  const location = useLocation();
  const navigate = useNavigate();

  function handleKitClick(event) {
    event.preventDefault();
    if (location.pathname === '/') {
      document.getElementById('reserve')?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    navigate({ pathname: '/', hash: 'reserve' });
  }

  return (
    <header className="site-header">
      <div className="shell header-inner">
        <Link to="/" className="wordmark" aria-label="Floro home">
          <img src="/logo.svg" alt="Floro" className="wordmark-logo" />
        </Link>
        <a href="/#reserve" className="btn-pill" onClick={handleKitClick}>
          Get your kit
        </a>
      </div>
    </header>
  );
}
